import { useState, useEffect } from 'react';

export function useSessionStorage(key: string, defaultValue: string) {
  const [value, setValue] = useState<string>(() => {
    try {
      const stored = sessionStorage.getItem(key);
      return stored ?? defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // ignore write errors
    }
  }, [key, value]);

  return [value, setValue] as const;
}
